import { Link } from 'react-router-dom';
import { statusMap } from "../../common/helpers";

export class MaintenanceTableConfig {
  static getColumns() {
    const columns = [
      {
        Header: 'Asset Name',
        accessor: 'assetName',
        Cell: ({ row }) => (
          <Link
            to={`/assets/${row.original.asset}/problems/${row.original.id}`}
            style={{ color: '#2185d0', textDecoration: 'underline' }}
          >
            {row.original.assetName}
          </Link>
        )
      },
      {
        Header: 'Device Type',
        accessor: 'assetType',
        Cell: ({ value }) => value || 'N/A'
      },
      {
        Header: 'Team',
        accessor: 'associatedTeam.name',
        Cell: ({ value }) => value || 'Unassigned'
      },
      {
        Header: 'Summary',
        accessor: 'summary',
        Cell: ({ value, row }) => (
          <b>{statusMap[value] || 'No summary'}</b>
        )
      },
      {
        Header: 'Location',
        accessor: 'address',
        Cell: ({ row }) => {
          const { address, city, state, business_name } = row.original;
          const location = [business_name, address, city, state].filter(Boolean).join(', ');
          return (
            <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {location || 'No location'}
            </div>
          );
        }
      },
      {
        Header: 'Assigned To',
        accessor: 'createdByName',
        Cell: ({ value, row }) => {
          return row.original.mechanicInfo?.name ? row.original.mechanicInfo.name : <div style={{ color: 'gray' }}>{value}</div>
        }
      },
      {
        Header: 'Last Modified',
        accessor: 'modifiedTime',
        Cell: ({ row }) => {
          const date = new Date(row.original.modifiedTime);
          return <div>{date.toLocaleDateString()}</div>;
        }
      }
    ];

    return columns;
  }
}

export default MaintenanceTableConfig;
